window.addEventListener("load", () => {
  const subMenuOpenButtons = document.querySelectorAll(".submenu-toggle");
  const subMenuCloseButtons = document.querySelectorAll(".submenu-back");

  subMenuOpenButtons.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();

      btn.closest("li.menu-item").classList.toggle("open");
    });
  });

  subMenuCloseButtons.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();

      btn.closest("li.menu-item").classList.remove("open");
    });
  });
});
